import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { shouldRestoreScroll } from '../utils/shopScrollRestore';

export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (shouldRestoreScroll(pathname, search)) {
      return;
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: pathname.startsWith('/product-details') ? 'auto' : 'smooth',
    });
  }, [pathname, search]);

  return null;
}
